import classnames from 'classnames';
import createReactClass from 'create-react-class';
import React from 'react';

import TimestampFormatter from './lib/timestamp_formatter';

const TimeAgo = createReactClass({
  getInitialState() {
    return { currentTime: new Date() };
  },

  componentDidMount() {
    this.startTimer();
  },

  componentWillUnmount() {
    clearInterval(this.timerInterval);
  },

  startTimer() {
    clearInterval(this.timerInterval);
    this.timerInterval = setInterval(this.updateCurrentTime, 30 * 1000);
  },

  updateCurrentTime() {
    this.setState({ currentTime: new Date() });
  },

  render() {
    let tf = new TimestampFormatter(this.props.timestamp);
    let fullTime = tf.full();
    let shortTime = tf.ago();

    return (
      <time className={classnames(this.props.className)} dateTime={this.props.timestamp} title={fullTime}>
        {shortTime}
      </time>
    );
  },
});

export default TimeAgo;



// WEBPACK FOOTER //
// ./src/scripts/presentation/components/lib/date/time_ago.jsx